import { render, staticRenderFns } from "./prompts.vue?vue&type=template&id=5ddfe1ed&scoped=true"
import script from "./prompts.vue?vue&type=script&lang=js"
export * from "./prompts.vue?vue&type=script&lang=js"
import style0 from "./prompts.vue?vue&type=style&index=0&id=5ddfe1ed&prod&lang=scss&scoped=true"
import style1 from "./prompts.vue?vue&type=style&index=1&id=5ddfe1ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfe1ed",
  null
  
)

export default component.exports